import { appsConf } from "./appDataConf.js";
import { chunksConf } from "./chunkDataConf.js";
import { dbName, dbVersion } from "./consts.js";
import { chunksMergeConf } from "./storeManagerConf/chunkCacheStoreManagerConf.js";


// этот класс для наследования был создан, т.е. надо подумать как его скомпоновать с IndexedDBManager
export class IndexedDBService {
    constructor(conf) {
        this.store = conf.store;
        this.dbName = conf.dbName;
        this.dbVersion = conf.dbVersion;

        this.requestCache = new Map; // id -> promise ///TODO seems irrelevant to class IndexedDBManager (could be renamed to Facade already)
    }
}


//Maybe rename to Facade
export class IndexedDBManager {
    constructor(
      dbName, 
      // dbVersion, 
      storeNameList,
    ) {
      if (
        !IndexedDBManager.dbNameToInstanceMap
      ) {
        IndexedDBManager.dbNameToInstanceMap = new Map;
      }

      if (
        IndexedDBManager.dbNameToInstanceMap.has(dbName)
      ) return IndexedDBManager.dbNameToInstanceMap.get(dbName);

      this.db = null;
      // this.queue = [];
      // this.isProcessing = false;

      this.dbName = dbName;
      // this.dbVersion = dbVersion;
      this.storeNameList = storeNameList;
      // this.storeNameList = [];

      IndexedDBManager.dbNameToInstanceMap.set(dbName, this);


      // this.db = new Promise((resolve, reject) => {

      // });


      // this.dbPrms = this.openDB();

      this.db = null;


      // this.db = this.openDB();

      // this 

      // this.openDB();
    }

    // TODO also remove outdated stores
    async checkAndCreateStore(storeName) {
      const databases = await indexedDB.databases();
      const dbInfo = databases.find(db => db.name === this.dbName);

      let storeExists = false;

      let self = this;

      if (
        dbInfo
      ) {
          storeExists = await new Promise((resolve, reject) => {
              const request = indexedDB.open(self.dbName);

              request.onsuccess = function(event) {
                  const db = event.target.result;
                  const exists = db.objectStoreNames.contains(storeName);
                  db.close();
                  resolve(exists);
              };

              request.onerror = function(event) {
                  reject(event.target.error);
              };
          });

          //TODO try catch for promise reject
      }

      if (
        !storeExists
      ) {
          return new Promise((resolve, reject) => {
              const request = indexedDB.open(self.dbName, dbInfo ? dbInfo.version + 1 : 1);

              request.onupgradeneeded = function(event) {
                  const db = event.target.result;
                  if (
                    !db.objectStoreNames.contains(storeName)
                  ) {
                      db.createObjectStore(storeName);
                  }
              };

              request.onsuccess = function(event) {
                  const db = event.target.result;
                  db.close();
                  resolve();
              };

              request.onerror = reject;
          });


          //TODO try catch for reject
      }

      //TODO maybe not return anything it will be ok for promise resolve
      return true;
    }

// // Usage example
// checkAndCreateStore('myDatabase', 'myObjectStore').then(() => {
//   console.log('Check and creation (if necessary) complete.');
// }).catch(error => {
//   console.error('Error checking and creating object store:', error);
// });

  
    async openDB() {

      // TODO remove outdated stores before also


      if (this.db) return this.db;

      let resolver, rejecter;

      let dbPrms = new Promise((resolve, reject) => {
        resolver = resolve;
        rejecter = reject;
      });

      for (let storeName of this.storeNameList) {
        await this.checkAndCreateStore(storeName);
      }



      let self = this;
  
      // return new Promise((resolve, reject) => {
        // const request = indexedDB.open(this.dbName, this.dbVersion);
        const request = indexedDB.open(this.dbName);
  
        // request.onupgradeneeded = (event) => {
        //   const db = event.target.result;

        //   this.storeNameList.forEach(storeName => {
        //     if (
        //       !db.objectStoreNames.contains(storeName)
        //     ) {
        //       db.createObjectStore(storeName);
        //     }
        //   });
        // };
  
        request.onsuccess = (event) => {
          self.db = event.target.result;

          // let version = this.db.version;

          resolver(this.db);
        };
  
        request.onerror = rejecter;

        return dbPrms;
      // });
    }
  
    async executeOperation(storeName, operation) {

      //this get executed more than 1 time
      let db = await this.openDB();

      // if (
      //   !this.db
      // ) {
      //   throw new Error("Database not initialized. Call openDB first.");
      // }


      // await this.db;


      // let self = this;

      // await this.db;
  
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(storeName, 'readwrite'); //TODO not all operations readwrite
        const store = transaction.objectStore(storeName);
  
        transaction.oncomplete = () => resolve();
        transaction.onerror = (event) => reject(`Transaction failed: ${event.target.error}`);
  
        try {
          operation(store);
        } catch (error) {
          reject(`Operation failed: ${error.message}`);
        }
      });
    }
  

    // в инете пишут что индексдб сам хендлит транзакции, может не нужно вообще городить эти конструкции


    // async enqueueOperation(storeName, type, operation) {
    //   await this.ensureStoreExists(storeName); // Ensure the store exists <-----------------------
    //   const db = await this.dbPromise;
    //   return new Promise((resolve, reject) => {
    //     const transaction = db.transaction(storeName, type);
    //     const store = transaction.objectStore(storeName);
    //     const request = operation(store);
  
    //     request.onsuccess = (event) => {
    //       resolve(event.target.result);
    //     };
  
    //     request.onerror = (event) => {
    //       reject(event.target.error);
    //     };
    //   });
    // }


    async enqueueOperation(storeName, operation) {
      this.queue.push({ storeName, operation });
  
      if (!this.isProcessing) {
        this.isProcessing = true;
        while (this.queue.length > 0) {
          const { storeName, operation } = this.queue.shift();
          try {
            await this.executeOperation(storeName, operation);
          } catch (error) {
            console.error('Operation failed:', error);
          }
        }
        this.isProcessing = false;
      }
    }

    // единственное что тут не нравится - версия динамически меняется
    async ensureStoreExists(storeName) {

    }


    // async ensureStoreExists(storeName) {
    //   const db = await this.dbPromise;
    //   if (!db.objectStoreNames.contains(storeName)) {
    //     this.db.close();
    //     const version = db.version + 1;
    //     const request = indexedDB.open(this.dbName, version);
  
    //     request.onupgradeneeded = (event) => {
    //       const upgradedDb = event.target.result;
    //       if (!upgradedDb.objectStoreNames.contains(storeName)) {
    //         upgradedDb.createObjectStore(storeName, { keyPath: 'id', autoIncrement: true });
    //       }
    //     };
  
    //     return new Promise((resolve, reject) => {
    //       request.onsuccess = (event) => {
    //         this.db = event.target.result;
    //         this.dbPromise = Promise.resolve(this.db); // Update the dbPromise
    //         resolve(this.db);
    //       };
  
    //       request.onerror = (event) => {
    //         reject(event.target.error);
    //       };
    //     });
    //   }
    //   return Promise.resolve(db);
    // }

    async createObjectStore(storeName) {


    // async createObjectStore(storeName) {
    //   const db = await this.dbPromise;
    //   if (!db.objectStoreNames.contains(storeName)) {
    //     db.close();
    //     const version = db.version + 1;
    //     const request = indexedDB.open(this.dbName, version);
    
    //     request.onupgradeneeded = (event) => {
    //       const upgradedDb = event.target.result;
    //       if (!upgradedDb.objectStoreNames.contains(storeName)) {
    //         upgradedDb.createObjectStore(storeName, { keyPath: 'id', autoIncrement: true });
    //       }
    //     };
    
    //     return new Promise((resolve, reject) => {
    //       request.onsuccess = (event) => {
    //         this.db = event.target.result;
    //         resolve(this.db);
    //       };
    
    //       request.onerror = (event) => {
    //         reject(event.target.error);
    //       };
    //     });
    //   }
    //   return Promise.resolve(db);
    // }

    }
  }
  
  export const gudhubIndexedDBManager = new IndexedDBManager(
    dbName,
    // dbVersion, 
    [
      appsConf.store,
      chunksConf.store,
      chunksMergeConf.store,
    ],
  );

  // export default dbManager;  



  // последний ответ посмотри, там я спрашивал можно ли не закрывать и открывать дб из каждого сторменеджера


  // await this.ensureStoreExists(storeName); // Ensure the store exists - вот этот код вроде ок, т.е. перед выполнением след операции проверка

  
